import { render, staticRenderFns } from "./OutputBox.vue?vue&type=template&id=1daab960&scoped=true"
import script from "./OutputBox.vue?vue&type=script&lang=ts"
export * from "./OutputBox.vue?vue&type=script&lang=ts"
import style0 from "./OutputBox.vue?vue&type=style&index=0&id=1daab960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1daab960",
  null
  
)

export default component.exports